<template>
    <button id="PAGE_DOWN" name="PAGE_DOWN" class="btn" data-vcode="PAGE_DOWN">
        <img src="/images/icons/pageDown.svg" alt="" role="img" aria-hidden="true" />
        <label>{{ $t('pageDown') }}</label>
    </button>
</template>
<script>
export default {};
</script>
